
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "index.css";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { store } from './store';
import { Provider } from 'react-redux'
import { applyTheme, getPreferredTheme } from "components/shared/ThemeToggle";

// Ensure theme is set before first paint (also applied inline in public/index.html).
applyTheme(getPreferredTheme());

const login = sessionStorage.getItem("token");
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer />
        <Switch>
          {login ? (
            <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
          ) : (
            <Route path="/" render={(props) => <AuthLayout {...props} />} />
          )}

          <Redirect from="/" to="/admin/index" />
        </Switch>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// root.render();
